import {
  WSBreadcrumbsItem,
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import { PayerStatus } from "@wingspanhq/wingspan-api-sdk";
import { queriesPayers } from "@query";
import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { WSQueries } from "../../../query/WSQuery";
import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import { selectorCounterpartyDisplayName } from "../../../shared/selectors/selectorCounterpartyDisplayName";
import { usePayerHistoryResources } from "../hooks/usePayerHistoryResources";
import { getPayerDetailsUrl, PAYERS_PATH } from "../paths";

export const RoutePayerHistory: React.FC = () => {
  const history = useHistory();
  const match = useRouteMatch<{ payerId: string }>();
  const payerId = match.params.payerId;
  // Direct `getPayer`, not the `searchPayerRows` projection. Both fields this
  // screen needs are on the entity (`profile` for the name, `status` for the
  // archived breadcrumb), and the screen gates its whole render on the read, so
  // a wobble in the search index took the page down with it. It also shares a
  // query key with the client-details screen the breadcrumb links back to, which
  // reads the same entity — so navigating between them serves from cache and the
  // two now agree on the name. The trade is the server-resolved
  // `profile.resolvedName`, which only the row carries;
  // `selectorCounterpartyDisplayName` falls back displayName -> company DBA ->
  // email -> id.
  const queryPayer = queriesPayers.getPayer.useQuery({ payerId });

  const historyResources = usePayerHistoryResources(payerId);

  return (
    <WSPage>
      <WSQueries
        queries={{
          queryPayer
        }}
      >
        {({ queryPayerData }) => {
          const clientName = selectorCounterpartyDisplayName(queryPayerData);

          const isInactive = queryPayerData.status !== PayerStatus.ACTIVATED;

          return (
            <>
              <WSPageToolbar
                title="Client history"
                breadcrumbs={[
                  {
                    label: "Clients",
                    onClick: () => {
                      history.push(PAYERS_PATH);
                    }
                  },
                  ...(isInactive
                    ? [
                        {
                          label: "Archived clients",
                          onClick: () => {
                            history.push(`${PAYERS_PATH}/archived`);
                          }
                        } as WSBreadcrumbsItem
                      ]
                    : []),
                  {
                    label: clientName,
                    onClick: () => {
                      history.push(getPayerDetailsUrl(payerId));
                    }
                  },
                  {
                    label: "Client history"
                  }
                ]}
              />

              <WSGrid>
                <WSGrid.Item span={{ l: "8" }}>
                  <WSList gap="2XL">
                    <ResourceHistory resources={historyResources} />
                  </WSList>
                </WSGrid.Item>
              </WSGrid>
            </>
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
